// theme.js — MUI theme aligned with /app/design_guidelines.json
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  shape: { borderRadius: 6 },
  typography: {
    fontFamily: '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600, letterSpacing: "-0.02em" },
    h2: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600, letterSpacing: "-0.02em" },
    h3: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600, letterSpacing: "-0.02em" },
    h4: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600, letterSpacing: "-0.02em" },
    h5: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600, letterSpacing: "-0.02em" },
    h6: { fontWeight: 600, letterSpacing: "-0.01em" },
    button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.01em" },
    overline: { fontWeight: 600, letterSpacing: "0.12em", fontSize: "0.7rem" },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#1E2A38",
      dark: "#0F1721",
      light: "#2C3E50",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#2E5A35", // sage / institutional green
      dark: "#1f4023",
      light: "#A3C2A9",
      contrastText: "#FFFFFF",
    },
    success: { main: "#2E5A35" },
    warning: { main: "#8F5E14" },
    error: { main: "#A93226" },
    background: { default: "#F7F7F6", paper: "#FFFFFF" },
    text: { primary: "#111827", secondary: "#4B5563" },
    divider: "#E2E8F0",
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 4,
          paddingInline: 16,
          paddingBlock: 7,
          fontSize: "0.83rem",
          transition: "all 0.18s ease",
        },
        contained: {
          boxShadow: "none",
          "&:hover": { boxShadow: "0 2px 6px rgba(30,42,56,0.18)" },
        },
        outlined: {
          borderColor: "#CBD5E1",
          color: "#1E2A38",
          "&:hover": { borderColor: "#1E2A38", background: "#F7F7F6" },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          border: "1px solid #E2E8F0",
          boxShadow: "none",
          backgroundImage: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 6, border: "1px solid #E2E8F0", boxShadow: "none" },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          backgroundColor: "#FFFFFF",
          fontSize: "0.88rem",
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1E2A38" },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderWidth: 1.5, borderColor: "#1E2A38" },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          background: "#F0EFEA",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontSize: "0.7rem",
          letterSpacing: "0.1em",
          fontWeight: 600,
          color: "#4B5563",
          textTransform: "uppercase",
          borderBottom: "1px solid #CBD5E1",
        },
        body: {
          fontSize: "0.85rem",
          borderBottom: "1px solid #F0EFEA",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, fontSize: "0.85rem", letterSpacing: 0 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 4, fontFamily: '"IBM Plex Mono", monospace', fontSize: "0.7rem" },
      },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 8, border: "1px solid #E2E8F0" } },
    },
    MuiAlert: { styleOverrides: { root: { borderRadius: 4 } } },
    MuiTooltip: {
      styleOverrides: { tooltip: { background: "#1E2A38", fontSize: "0.74rem" } },
    },
  },
});

export default theme;
